<template>
  <v-container fluid class="auth-bg fill-height">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" sm="10" md="7" lg="5">
        <v-card class="auth-card pa-8">
          <div class="auth-section-header justify-center">
            <v-icon small color="primary" class="mr-2">mdi-google</v-icon>
            <span class="auth-section-title">Autenticação Google</span>
          </div>

          <div class="d-flex align-center justify-center mb-6 mt-4">
            <v-avatar size="72" class="google-avatar">
              <v-icon size="38" color="#EA4335">mdi-google</v-icon>
            </v-avatar>
          </div>

          <div class="text-center">
            <div class="auth-title mb-2">Conectando sua conta</div>
            <div class="auth-subtitle">
              Estamos finalizando seu login com o Google…
            </div>
          </div>

          <div class="d-flex justify-center my-8">
            <v-progress-circular
              indeterminate
              size="48"
              width="4"
              color="primary"
            />
          </div>

          <v-alert
            v-if="error"
            type="error"
            outlined
            border="left"
            class="auth-alert mb-0"
          >
            {{ error }}
            <div class="mt-3 d-flex justify-end">
              <v-btn text color="primary" @click="goHome">
                Voltar para login
              </v-btn>
            </div>
          </v-alert>

          <div v-else class="text-center auth-hint">
            Se demorar muito, verifique sua conexão.
          </div>
        </v-card>

        <div class="text-center mt-4 auth-footer">
          © {{ new Date().getFullYear() }} Salvia
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    error: "",
  }),

  async created() {
    const code = this.$route.query.code;
    if (!code) return this.$router.replace("/");

    try {
      const { user, needsRole } = await this.$store.dispatch(
        "auth/loginWithGoogle",
        { code },
      );

      if (needsRole || !user?.role_id) {
        return this.$router.replace({ name: "ChooseRolePage" });
      }

      const redirect = this.$route.query.redirect;
      if (redirect) return this.$router.replace(redirect);

      const userType = this.$store.getters["auth/userType"];

      if (userType === "assistant") {
        this.$router.replace({
          path: "/calendar-page",
          query: { mode: "clinic" },
        });
      } else if (userType === "doctor_solo" || userType === "doctor_clinic") {
        this.$router.replace({
          path: "/calendar-page",
          query: { mode: "doctor" },
        });
      } else {
        this.$router.replace({ name: "PatientsPage" });
      }
    } catch (e) {
      this.error =
        "Não foi possível finalizar o login com o Google. Tente novamente.";
      // opcional: manter seu redirect automático
      // this.$router.replace("/?google_error=1");
    }
  },

  methods: {
    goHome() {
      this.$router.replace("/?google_error=1");
    },
  },
};
</script>

<style scoped>
.auth-bg {
  background: radial-gradient(
    1200px circle at 20% 10%,
    var(--ds-blue-100) 0%,
    var(--ds-surface-white) 45%,
    var(--ds-blue-bg) 100%
  );
}

.auth-card {
  border-radius: 18px;
  box-shadow: 0 12px 32px rgba(31, 77, 63, 0.08),
    0 2px 6px rgba(0, 0, 0, 0.04) !important;
}

.auth-section-header {
  display: flex;
  align-items: center;
  padding-bottom: 6px;
}

.auth-section-title {
  font-size: 11px;
  font-weight: 700;
  color: var(--ds-primary);
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.google-avatar {
  background: var(--ds-surface-white) !important;
  border: 2px solid var(--ds-blue-100);
  box-shadow: 0 4px 12px rgba(31, 77, 63, 0.12);
}

.auth-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--ds-text-strong);
  letter-spacing: -0.3px;
}

.auth-subtitle {
  font-size: 13px;
  color: var(--ds-text-soft);
  font-weight: 500;
}

.auth-alert {
  border-radius: 10px !important;
}

.auth-hint {
  font-size: 11px;
  color: var(--ds-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-weight: 500;
}

.auth-footer {
  font-size: 11px;
  color: var(--ds-text-muted);
  letter-spacing: 0.3px;
}
</style>
